import { AnnotationQuestion } from "@untitledui/icons";

export const ReconnectCallout = () => (
  <div className="flex w-full flex-col items-start gap-1 rounded-lg bg-[#abebdd] px-6 py-5">
    <div className="flex w-full items-center gap-1.5">
      <AnnotationQuestion className="h-5 w-5 shrink-0 text-primary" />
      <p className="flex-1 text-sm font-medium text-primary">
        We've made Improvements to our platform. Please reconnect to authenticate
      </p>
    </div>
    <p className="w-full text-sm text-primary">Without access, some features may not update or function as expected.</p>
  </div>
);
